//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { WorkflowProgress } from 'unison';

import { ExitConfirmationModalActions } from '@catalog-ingestion/actions/exitConfirmationModalActions';
import { GoogleCatalogIngestionModalActions } from '@catalog-ingestion/actions/googleCatalogIngestionModalActions';
import ConnectPanel from '@catalog-ingestion/components/connect-panel/ConnectPanel';
import { IngestionModal } from '@catalog-ingestion/components/modals/ingestion-modal/IngestionModal';
import ProcessPanel from '@catalog-ingestion/components/process-panel/ProcessPanel';
import { ReviewPanel } from '@catalog-ingestion/components/review-panel/ReviewPanel';
import {
  WORKFLOW_PANELS,
  progressSteps,
} from '@catalog-ingestion/constants/googleCatalogIngestionModalConstants';

export const GoogleCatalogIngestionModal = () => {
  const dispatch = useDispatch();

  const { isOpen, currentPanel } = useSelector(
    (state) => state.catalogIngestionReducers.googleCatalogIngestionModal,
  );

  function displayedPanel() {
    switch (currentPanel) {
      case WORKFLOW_PANELS.CONNECT_PANEL:
        return <ConnectPanel />;
      case WORKFLOW_PANELS.REVIEW_PANEL:
        return <ReviewPanel />;
      case WORKFLOW_PANELS.PROCESS_PANEL:
        return <ProcessPanel />;
    }
  }

  const { openExitConfirmationModal } = ExitConfirmationModalActions;
  const { resetAndCloseWorkflow, getNextPanel } =
    GoogleCatalogIngestionModalActions;

  return (
    <IngestionModal
      headerTitle={'Connect Product Catalog'}
      isOpen={isOpen}
      onClose={() => dispatch(openExitConfirmationModal())}
      onDone={resetAndCloseWorkflow}
      onNext={() => dispatch(getNextPanel())}
      currentPanel={currentPanel}
      lastPanel={WORKFLOW_PANELS.PROCESS_PANEL}
    >
      <ContentContainer>
        <ContentBox>
          <StyledWorkflowProgress
            className='cu-py-4'
            currentStep={currentPanel}
            workflowProgressSteps={progressSteps}
          />
          {displayedPanel()}
        </ContentBox>
      </ContentContainer>
    </IngestionModal>
  );
};

const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacings[2]} 0;
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({ theme }) => theme.spacings[4]};
  width: 70%;
  margin: 0 auto;
`;

const StyledWorkflowProgress = styled(WorkflowProgress)`
  flex-wrap: wrap;
  padding: ${({ theme }) => theme.spacings[4]} 0;
`;
